var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 10.2246L16.5 14.6153L12.1093 10.2246L10.224 12.1099L14.6147 16.5006L10.224 20.8913L12.1093 22.7766L16.5 18.3859L20.8906 22.7766L22.776 20.8913L18.3853 16.5006L22.776 12.1099L20.8906 10.2246Z",
    fill: "#067D89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.5C13.3355 0.5 10.2421 1.43838 7.61088 3.19649C4.9797 4.95459 2.92894 7.45345 1.71793 10.3771C0.506933 13.3007 0.190079 16.5177 0.807443 19.6214C1.42481 22.7251 2.94866 25.5761 5.1863 27.8137C7.42394 30.0513 10.2749 31.5752 13.3786 32.1926C16.4823 32.8099 19.6993 32.4931 22.6229 31.2821C25.5466 30.0711 28.0454 28.0203 29.8035 25.3891C31.5616 22.7579 32.5 19.6645 32.5 16.5C32.4954 12.2579 30.8082 8.19095 27.8086 5.19136C24.8091 2.19177 20.7421 0.504588 16.5 0.5V0.5ZM16.5 29.8333C13.8629 29.8333 11.2851 29.0513 9.0924 27.5863C6.89975 26.1212 5.19078 24.0388 4.18161 21.6024C3.17244 19.1661 2.9084 16.4852 3.42287 13.8988C3.93734 11.3124 5.20722 8.93661 7.07192 7.07191C8.93661 5.20721 11.3124 3.93733 13.8988 3.42286C16.4852 2.90839 19.1661 3.17244 21.6024 4.18161C24.0388 5.19077 26.1212 6.89974 27.5863 9.0924C29.0513 11.2851 29.8333 13.8629 29.8333 16.5C29.8295 20.035 28.4234 23.4242 25.9238 25.9238C23.4242 28.4234 20.035 29.8294 16.5 29.8333V29.8333Z",
    fill: "#067D89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderXIcon);
export default __webpack_public_path__ + "static/media/border-x-icon.6108d256fd8264b603e3d1673ed548b5.svg";
export { ForwardRef as ReactComponent };